<!--
 * @Descripttion:
 * @Author: kongweiqiang
 * @Date: 2021-09-07 09:13:08
 * @LastEditors: liang
 * @LastEditTime: 2021-09-13 15:02:44
-->
<template>
  <div class="box">
    <div class="bg">
      <el-card shadow="never">
        <el-row :gutter="20">
          <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
            <el-form-item>
              <el-input v-model="dataForm.examPaperName" clearable placeholder="考试名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="dataForm.year" type="year" value-format="yyyy" placeholder="选择年">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.isPass" clearable placeholder="请选择通过状态">
                <el-option v-for="item in isPassOptions" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getDataList(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" @click="resetHandle()">重置</el-button>
            </el-form-item>
          </el-form>
        </el-row>
      </el-card>
      <el-card shadow="never" style="margin-top:20px;">
        <el-table v-loading="dataListLoading" :data="dataList" style="width: 100%;" border>
          <el-table-column prop="examPaperName" label="考试名称" header-align="center" align="center"></el-table-column>
          <el-table-column prop="year" label="年度" header-align="center" align="center" width="80px"></el-table-column>
          <el-table-column prop="userName" label="姓名" header-align="center" align="center" width="80px"></el-table-column>
          <el-table-column prop="deptName" label="所属单位" header-align="center" align="center"></el-table-column>
          <el-table-column prop="points" label="考试成绩" header-align="center" align="center" width="100px">
            <template slot-scope="scope">
              {{scope.row.points}} 分
            </template>
          </el-table-column>
          <el-table-column prop="points" label="考试结果" header-align="center" align="center" width="80px">
            <template slot-scope="scope">
              <el-tag type="danger" effect='dark' size="small" v-if="scope.row.isPass =='0'">不通过</el-tag>
              <el-tag type="success" effect='dark' size="small" v-if="scope.row.isPass =='1'">通过</el-tag>
              <el-tag type="warning" effect='dark' size="small" v-if="scope.row.isPass =='2'">待验证</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" v-if="scope.row.isPass !='2'" @click="displayHandle(scope.row.id)">查看详情</el-button>
              <el-button type="text" size="small" v-if="scope.row.isPass =='1'" @click="goPath('myplan')">查看证书</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding-top:20px;text-align:center;">
          <el-pagination :current-page="page" :page-sizes="[10]" :page-size="limit" :total="total" layout="total, prev, pager, next, jumper" @current-change="pageCurrentChangeHandle">
          </el-pagination>
        </div>

      </el-card>
    </div>
    <detail ref="detail" v-if="visible"></detail>
  </div>
</template>
<script>
import detail from './detail'
export default {
  data () {
    return {
      dataForm: {
        examPaperName: '',
        year: '',
        isPass: ''
      },
      defaultForm: {},
      isPassOptions: [],
      dataList: [],
      dataListLoading: false,
      visible: false,
      page: 1,
      limit: 10,
      total: 1
    }
  },
  components: { detail },
  mounted () {
    this.defaultForm = JSON.parse(JSON.stringify(this.dataForm))
    this.$store.dispatch('setNavIndex', '-5')
    this.getexamIsPass()
    this.getDataList(1)
  },
  methods: {
    // sys/dict/type/examIsPass
    // /client/exam/userExamHistoryPage
    resetHandle (data) {
      this.dataForm = JSON.parse(JSON.stringify(this.defaultForm))
      if (data) {
        for (var key in data) {
          this.dataForm[key] = data[key]
        }
      }
      this.page = 1
      this.getDataList()
    },
    displayHandle (id) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.detail.init(id)
      })
    },
    goPath (name) {
      this.$router.push({
        path: name,
        query: { activeName: 'six' }
      })
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      window.scrollTo(0, 0)
      this.getDataList()
    },
    getDataList (page) {
      let user = JSON.parse(localStorage.getItem('user'))
      this.dataListLoading = true
      this.$get(`/client/exam/userExamHistoryPage`, {
        page: page || this.page,
        limit: 10,
        userId: user.id,
        ...this.dataForm
      })
        .then((res) => {
          this.dataListLoading = false
          if (res.code !== 0) {
            this.dataList = []
            this.total = 0
            return false
          }
          console.log(res.data)
          this.dataList = res.data.list
          this.dataList.forEach((item, index) => {
            item._index =
              this.page - 1 === 0
                ? index + 1
                : index + 1 < this.limit
                  ? (this.page - 1) * this.limit + (index + 1)
                  : this.page * this.limit
          })
          this.total = res.data.total
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    getexamIsPass () {
      this.$get('/sys/dict/type/examIsPass')
        .then((res) => {
          this.isPassOptions = res.data.list
        })
        .catch(() => {})
    }
  }
}
</script>
<style  lang='scss' scoped>
.box {
  min-height: calc(100vh - 230px);
  background: #f7f7f7;
  overflow: hidden;
  padding-top: 20px;
  .bg {
    width: 1200px;
    margin: 0 auto;
    // background: white;
  }
}
</style>
